import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  error$: Subject<string> = new Subject();
  success$: Subject<string> = new Subject();
  loader$: Subject<boolean> = new BehaviorSubject(false);

  constructor() {}

  displaySuccess(value: string): void {
    this.success$.next(value);
  }

  displayError(value: string): void {
    this.error$.next(value);
  }

  displayLoader(value: boolean): void {
    this.loader$.next(value);
  }

  hideLoader(): void {
    this.loader$.next(false);
  }

  showLoader(): void {
    this.loader$.next(true);
  }
}
